import requireContext from '@/utils/require-context';

function getModules() {
	let requireModule;

	// Import all of the module files.
	if (process.env.NODE_ENV === 'test') {
		//when running jest, there's no webpack require
		requireModule = requireContext('../sections', true, /.*-module\.js$/i);
	} else {
		requireModule = require.context('@/sections', true, /.*-module\.js$/i);
	}

	var s = requireModule
		.keys()
		.map(requireModule) // import module
		.map(m => m.default); // get `default` export from each resolved module

	return s;
}

const modules = getModules();

export default {
	modules: modules,
	routes: () => {
		let requireRoute;

		// Import all of the routes files.
		if (process.env.NODE_ENV === 'test') {
			//when running jest, there's no webpack require
			requireRoute = requireContext(
				'../sections',
				true,
				/.*-routes\.js$/i
			);
		} else {
			requireRoute = require.context(
				'@/sections',
				true,
				/.*-routes\.js$/i
			);
		}

		const routes = requireRoute
			.keys()
			.map(requireRoute) // import module
			.map(m => m.default); // get `default` export from each resolved module
		return routes;
	}
};
